<template>
  <v-container>
    <estimate-constructor
      :curPrice="$store.state.curPrice"
      storeSaveFunc="createEstimate"
      :ownerId="$store.state.localCustomerId"
    ></estimate-constructor>
    <v-alert type="warning" dense outlined class="ma-3">
      Уважаемые клиенты! Обратите внимание, что конструктор сметы работает в режиме бета-версии. 
      Это значит, что данные по ценам на работы актуальные и автоматически подтягиваются из нашего прайс-листа,
      а цены на материалы могут отличаться от текущих - просим проверять их на сайте 
      поставщика <a href="https://leroymerlin.ru/" target="_blank">Леруа Мерлен</a>. Спасибо за понимание.
    </v-alert>
  </v-container>
</template>

<script>
import EstimateConstructor from '../components/__import/constructor/EstimateConstructor';

export default {
  components: {
    EstimateConstructor
  },

  created() {
    this.$store.dispatch('loadPrice');
  },
}
</script>